import React from "react";
import { isEmpty } from "lodash";
import { Row, Col, Modal } from "react-bootstrap";

import CloseButton from "components/closeButton";
import { convertDatesToLocal } from "helpers";

import styles from "./modal.module.scss";

type OwnerCheckListModalProps = {
	show: boolean;
	onHide: () => void;
	result: { [key: string]: any };
	title: string;
};

const OwnerCheckListModal = ({
	show,
	onHide,
	result,
	title,
}: OwnerCheckListModalProps) => {
	const { result: mainResult, accountResponseCodeDescription } = result || {};
	const splitMainResult = () =>
		mainResult &&
		convertDatesToLocal(mainResult).split(
			new RegExp(["\n"].join("|"), "g"),
		);
	const RenderResult = () =>
		splitMainResult() ? (
			<ul>
				{splitMainResult().map((item, index) => (
					<li key={index}>{item}</li>
				))}
			</ul>
		) : (
			<div className="text-center p-3">No Data</div>
		);

	return (
		<Modal
			show={show}
			onHide={onHide}
			centered
			className={styles.ownerCheckListWrapper}
		>
			<Modal.Header className={styles.modalHeader}>
				{title !== "Experian" ? (
					<Modal.Title as="h6" className="text-center">
						{title}
					</Modal.Title>
				) : null}
				<CloseButton onClick={onHide} />
			</Modal.Header>
			<Modal.Body className={styles.ownerCheckListBody}>
				<Row>
					<Col>
						<RenderResult />
					</Col>
				</Row>
				{!isEmpty(accountResponseCodeDescription) && (
					<Row className={"text-grey"}>
						<Col md={2}>Description:</Col>
						<Col md={7}>{accountResponseCodeDescription}</Col>
					</Row>
				)}
			</Modal.Body>
		</Modal>
	);
};

export default OwnerCheckListModal;
